import { createFormFields } from '@/shared/components/form-fields/factories/create-form-fields';
import { useFieldContext } from './payment-settings-form-context.hook';

export const PaymentSettingsFormFields = createFormFields(useFieldContext);
